import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from './Select';
import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import { clearFoods, getFoods } from '../../../../actions/food/Food';

const FoodSelect = ({
  dispatchGetFoods,
  dispatchClearFoods,
  foods,
  isLoading,
  isMulti,
  input,
  meta,
  ...rest
}) => {
  useLayoutEffect(() => {
    dispatchGetFoods({ ...DEFAULT_QUERY_GET_ALL });

    return () => {
      dispatchClearFoods();
    };
  }, []);

  return (
    <Select
      options={foods}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      {...rest}
    />
  );
};

FoodSelect.propTypes = {
  dispatchGetFoods: PropTypes.func.isRequired,
  dispatchClearFoods: PropTypes.func.isRequired,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  foods: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

FoodSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  isLoading: false,
  isMulti: false,
  foods: [],
  isDisabled: false,
};

const mapStateToProps = ({ FoodUnit }) => ({
  foods: FoodUnit.Food.getIn(['all', 'content', 'content']).map((food) => {
    '';

    return {
      value: food.id,
      label: `${food.name}`,
    };
  }),
  isLoading: FoodUnit.Food.getIn(['all', 'loading']),
});

const mapDispatchToprops = {
  dispatchGetFoods: getFoods,
  dispatchClearFoods: clearFoods,
};

export default connect(mapStateToProps, mapDispatchToprops)(FoodSelect);
